module.exports = __webpack_public_path__ + "media/images/entidades_organizadoras/fct-450a7712b1794397307db227e7c9dae6.svg";